var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-c round"},[_c('font-awesome-icon',{staticClass:"ml-2",attrs:{"icon":"plus","size":"md"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }